// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Rounded sliders */
.slider.round {
  border-radius: 20px;
}

.slider.round:before {
  border-radius: 50%;
}

div.lunchtime div.header {
  margin: 0 auto;
  max-width: 1440px;
  height: 56px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
}
@media only screen and (max-width: 600px) {
  div.lunchtime div.header {
    height: 100px;
  }
}
div.lunchtime div.header span.title {
  font-size: 32px;
  line-height: 32px;
  font-weight: bold;
  color: white;
  background-color: rgb(222, 41, 34);
  padding: 12px;
  box-sizing: border-box;
}
div.lunchtime div.header span.spacer {
  display: none;
}
div.lunchtime div.header span.subtitle {
  font-size: 24px;
  opacity: 0.7;
  flex-grow: 1;
  padding-left: 30px;
  padding-top: 5px;
}
div.lunchtime div.header span.user {
  position: relative;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}
div.lunchtime div.header span.user .menu-login {
  background-color: rgb(222, 41, 34);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
}
div.lunchtime div.header span.user .menu-login:hover {
  background-color: #444;
}
div.lunchtime div.header span.user .user-menu {
  position: relative;
}
div.lunchtime div.header span.user .user-menu .menu-trigger {
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: white;
  color: #444;
  border-radius: 6px;
  width: 40px;
  height: 36px;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
}
div.lunchtime div.header span.user .user-menu .menu-dropdown {
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  min-width: 220px;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);
  padding: 12px;
  z-index: 1200;
}
div.lunchtime div.header span.user .user-menu .menu-dropdown .menu-user-name {
  font-weight: 600;
  color: #444;
  margin-bottom: 4px;
  word-break: break-word;
}
div.lunchtime div.header span.user .user-menu .menu-dropdown .menu-user-email {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 10px;
  word-break: break-word;
}
div.lunchtime div.header span.user .user-menu .menu-dropdown .menu-logout {
  width: 100%;
  background-color: rgb(222, 41, 34);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
}
div.lunchtime div.header span.user .user-menu .menu-dropdown .menu-logout:hover {
  background-color: #444;
}
div.lunchtime div.header span.user .user-menu .menu-dropdown .menu-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
div.lunchtime div.header span #logout-button {
  margin-left: 2px;
}
div.lunchtime div.hero {
  max-width: 1440px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding: 40px 0;
  margin: 0 auto;
}
div.lunchtime div.hero div.step {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 33%;
  padding: 0 30px;
}
div.lunchtime div.hero div.step div.bubble {
  height: 180px;
  width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
}
div.lunchtime div.hero div.step div.bubble i.fa {
  color: rgb(222, 41, 34);
  font-size: 76px;
}
div.lunchtime div.hero div.step h2 {
  color: #444;
  margin: 0 0 6px 0;
  text-align: center;
}
div.lunchtime div.hero div.step article {
  text-align: center;
  width: 80%;
  color: rgba(0, 0, 0, 0.6);
  opacity: 0.8;
}
div.lunchtime div.dates {
  background-color: rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 60px 0;
  position: relative;
}
div.lunchtime div.dates div.longterm {
  position: absolute;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 50px;
  top: 0;
  right: 0;
  padding-left: 5px;
  padding-right: 5px;
  /* Hide default HTML checkbox */
  /* The slider */
}
@media only screen and (max-width: 600px) {
  div.lunchtime div.dates div.longterm {
    position: initial;
    width: 100%;
    justify-content: center;
  }
}
div.lunchtime div.dates div.longterm .switch {
  position: relative;
  margin-left: 5px;
  width: 43px;
  height: 20px;
  z-index: 2;
}
div.lunchtime div.dates div.longterm .switch input {
  display: none;
}
div.lunchtime div.dates div.longterm .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}
div.lunchtime div.dates div.longterm .slider:before {
  position: absolute;
  content: "";
  height: 24px;
  width: 24px;
  left: 0px;
  bottom: -2px;
  background-color: #ffffff;
  transition: 0.4s;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4);
}
div.lunchtime div.dates div.longterm input:checked + .slider {
  background-color: #82c800;
}
div.lunchtime div.dates div.longterm input:checked + .slider.beamer {
  background-color: #0064aa;
}
div.lunchtime div.dates div.longterm input:checked + .slider:before {
  transform: translateX(20px);
}
div.lunchtime div.dates h1.date-title {
  color: #444;
  font-size: 40px;
  font-weight: 200;
  align-self: center;
  opacity: 0.8;
  margin: 0;
  padding: 0;
}
div.lunchtime div.dates h2.date-subtitle {
  font-weight: 100;
  margin: 0;
  margin-bottom: 40px;
  font-size: 22px;
  opacity: 0.6;
}
@media only screen and (max-width: 600px) {
  div.lunchtime div.dates h2.date-subtitle {
    margin-bottom: 60px;
  }
}
div.lunchtime div.dates div.appointments {
  display: flex;
  justify-content: center;
  align-items: center;
}
div.lunchtime div.dates div.appointments div.day-group {
  margin: 5px;
}
div.lunchtime div.dates div.appointments div.day {
  width: 100%;
  background-color: #444;
  color: white;
  padding: 10px 0;
  text-align: center;
  font-size: 18px;
  border-radius: 30px 30px 0 0;
}
div.lunchtime div.dates div.appointments div.appointments-row {
  border: solid 1px;
  padding-top: 10px;
  padding-bottom: 10px;
}
div.lunchtime div.dates div.appointments div.appointment {
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  height: 160px;
  width: 200px;
  margin: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding-bottom: 6px;
  background-color: white;
  position: relative;
  margin-bottom: 20px;
}
div.lunchtime div.dates div.appointments div.appointment div.check {
  position: absolute;
  top: 0;
  left: 0;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  height: 100%;
  width: 100%;
  opacity: 0;
}
div.lunchtime div.dates div.appointments div.appointment div.check span {
  color: black;
}
div.lunchtime div.dates div.appointments div.appointment div.check i.fa {
  font-size: 60px;
  line-height: 70px;
  color: rgb(107, 171, 45);
}
div.lunchtime div.dates div.appointments div.appointment span {
  font-size: 14px;
}
div.lunchtime div.dates div.appointments div.appointment div.combined {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
}
div.lunchtime div.dates div.appointments div.appointment div.combined span.big-number {
  color: #444;
  font-size: 22px;
  line-height: 22px;
  font-weight: bold;
}
div.lunchtime div.dates div.appointments div.appointment div.combined span.noon {
  margin-top: 10px;
  color: #444;
  font-size: 28px;
  font-weight: bold;
  opacity: 1;
}
div.lunchtime div.dates div.appointments div.appointment.selected {
  background-color: rgb(177, 198, 16);
  color: white;
}
div.lunchtime div.dates div.appointments div.appointment.selected div.combined span.big-number {
  color: white;
}
div.lunchtime div.dates div.appointments div.appointment.selected div.combined span.noon {
  color: white;
}
div.lunchtime div.dates div.appointments div.appointment.isLocked {
  opacity: 0.4;
  cursor: default;
}
div.lunchtime div.dates div.appointments div.appointment.isLocked:hover {
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.1);
}
div.lunchtime div.dates div.appointments div.appointment:hover {
  box-shadow: 0px 8px 14px 2px rgba(0, 0, 0, 0.1);
}
div.lunchtime div#login-hint {
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.05);
  text-align: center;
}
div.lunchtime div#login-hint .menu-login {
  background-color: rgb(222, 41, 34);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 12px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  margin: 0 6px;
}
div.lunchtime div#login-hint .menu-login:hover {
  background-color: #444;
}
div.lunchtime div.suggestions {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  margin-bottom: 20px;
}
div.lunchtime div.suggestions h1 {
  color: #444;
  font-size: 40px;
  font-weight: 200;
  align-self: center;
  opacity: 0.8;
  width: 570px;
  text-align: center;
}
div.lunchtime div.suggestions button {
  align-self: center;
  cursor: pointer;
}
div.lunchtime div.footer {
  background-color: #444;
  color: white;
}
div.lunchtime div.footer div.links {
  width: 80%;
  padding: 20px;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
div.lunchtime div.footer div.links h2 {
  flex-grow: 1;
}
div.lunchtime div.footer div.links span {
  margin: 0 10px;
  opacity: 0.8;
  font-size: 12px;
  cursor: pointer;
}
div.lunchtime div.footer div.links span:hover {
  opacity: 1;
}

button.feedback-cta {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  background-color: rgb(222, 41, 34);
  color: white;
  border: none;
  border-radius: 8px 0 0 8px;
  padding: 12px 10px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  writing-mode: vertical-rl;
  text-orientation: mixed;
  letter-spacing: 1px;
  min-height: 120px;
}
button.feedback-cta:hover {
  background-color: #444;
}

modal#corona .corona-info {
  padding: 20px 40px;
}

modal#longterm .longterm-info {
  padding: 20px 40px;
}

@media (max-width: 1024px), (orientation: portrait) {
  div.modal {
    display: none;
  }
  div.lunchtime div.header span.subtitle {
    display: none;
  }
  div.lunchtime div.header span.spacer {
    flex-grow: 1;
    display: flex;
  }
  div.lunchtime div.hero {
    display: none;
  }
  div.lunchtime div.dates {
    padding-bottom: 40px;
  }
  div.lunchtime div.dates div.appointments {
    flex-direction: column;
    justify-content: flex-start;
  }
  div.lunchtime div.dates div.appointments div.appointment {
    margin-bottom: 40px;
  }
  div.lunchtime div.suggestions {
    display: none;
  }
  div.lunchtime div.footer div.links span {
    display: none;
  }
}
modal#feedback .feedback {
  padding: 20px 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/home/home.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA,oBAAA;AAEA;EACI,mBAAA;AAFJ;;AAKA;EACI,kBAAA;AAFJ;;AAMI;EACI,cAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,aAAA;AAHR;AAKQ;EATJ;IAUQ,aAAA;EAFV;AACF;AAKY;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,kCCxBP;EDyBO,aAAA;EACA,sBAAA;AAHhB;AAMY;EACI,aAAA;AAJhB;AAOY;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AALhB;AAQY;EACI,kBAAA;EACA,eAAA;EACA,yBClDJ;AD4CZ;AAQgB;EACI,kCC/CX;EDgDW,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;AANpB;AAQoB;EACI,sBCjEZ;AD2DZ;AAUgB;EACI,kBAAA;AARpB;AAUoB;EACI,oCAAA;EACA,iBAAA;EACA,WC3EZ;ED4EY,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AARxB;AAWoB;EACI,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,aAAA;AATxB;AAWwB;EACI,gBAAA;EACA,WClGhB;EDmGgB,kBAAA;EACA,sBAAA;AAT5B;AAYwB;EACI,eAAA;EACA,yBCvGhB;EDwGgB,mBAAA;EACA,sBAAA;AAV5B;AAawB;EACI,WAAA;EACA,kCCxGnB;EDyGmB,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;AAX5B;AAa4B;EACI,sBC1HpB;AD+GZ;AAewB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;AAb5B;AAmBY;EACI,gBAAA;AAjBhB;AAsBI;EACI,iBAAA;EACA,aAAA;EACA,6BAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AApBR;AAsBQ;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;AApBZ;AAsBY;EACI,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AApBhB;AAsBgB;EACI,uBChKX;EDiKW,eAAA;AApBpB;AAwBY;EACI,WC9KJ;ED+KI,iBAAA;EACA,kBAAA;AAtBhB;AAyBY;EACI,kBAAA;EACA,UAAA;EACA,yBCpLJ;EDqLI,YAAA;AAvBhB;AA4BI;EACI,qCCxLW;EDyLX,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AA1BR;AA4BQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,MAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EAeA,+BAAA;EAIA,eAAA;AA3CZ;AA0BY;EAXJ;IAYQ,iBAAA;IACA,WAAA;IACA,uBAAA;EAvBd;AACF;AAyBY;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAvBhB;AA0BY;EACI,aAAA;AAxBhB;AA2BY;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EAEA,gBAAA;AAzBhB;AA4BY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;EAEA,gBAAA;EACA,0CAAA;AA1BhB;AA6BY;EACI,yBAAA;AA3BhB;AA6BgB;EACI,yBAAA;AA3BpB;AA+BY;EAGI,2BAAA;AA7BhB;AAiCQ;EACI,WC3QA;ED4QA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AA/BZ;AAkCQ;EACI,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAhCZ;AAmCY;EARJ;IASQ,mBAAA;EAhCd;AACF;AAmCQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAjCZ;AAmCY;EACI,WAAA;AAjChB;AAoCY;EACI,WAAA;EACA,sBC5SJ;ED6SI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AAlChB;AAqCY;EACI,iBAAA;EACA,iBAAA;EACA,oBAAA;AAnChB;AAsCY;EACI,8CAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AApChB;AAsCgB;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AApCpB;AAsCoB;EACI,YAAA;AApCxB;AAuCoB;EACI,eAAA;EACA,iBAAA;EACA,wBCrVR;ADgThB;AAyCgB;EACI,eAAA;AAvCpB;AA2CgB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAzCpB;AA2CoB;EACI,WC/WZ;EDgXY,eAAA;EACA,iBAAA;EACA,iBAAA;AAzCxB;AA4CoB;EACI,gBAAA;EACA,WCvXZ;EDwXY,eAAA;EACA,iBAAA;EACA,UAAA;AA1CxB;AA8CgB;EACI,mCCrXF;EDsXE,YAAA;AA5CpB;AA+CwB;EACI,YAAA;AA7C5B;AAgDwB;EACI,YAAA;AA9C5B;AAmDgB;EACI,YAAA;EACA,eAAA;AAjDpB;AAmDoB;EACI,8CAAA;AAjDxB;AAqDgB;EACI,+CAAA;AAnDpB;AAyDI;EACI,aAAA;EACA,qCC1ZW;ED2ZX,kBAAA;AAvDR;AAyDQ;EACI,kCC3ZH;ED4ZG,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;EACA,aAAA;AAvDZ;AAyDY;EACI,sBC9aJ;ADuXZ;AA4DI;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;AA1DR;AA4DQ;EACI,WC3bA;ED4bA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AA1DZ;AA6DQ;EACI,kBAAA;EACA,eAAA;AA3DZ;AA+DI;EACI,sBC3cI;ED4cJ,YAAA;AA7DR;AA+DQ;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AA7DZ;AA+DY;EACI,YAAA;AA7DhB;AAgEY;EACI,cAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AA9DhB;AAgEgB;EACI,UAAA;AA9DpB;;AAqEA;EACI,eAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EAEA,kCCveK;EDweL,YAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;EAEA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AApEJ;AAsEI;EACI,sBC9fI;AD0bZ;;AAyEI;EACI,kBAAA;AAtER;;AA2EI;EACI,kBAAA;AAxER;;AA4EA;EACI;IACI,aAAA;EAzEN;EA8EU;IACI,aAAA;EA5Ed;EA+EU;IACI,YAAA;IACA,aAAA;EA7Ed;EAiFM;IACI,aAAA;EA/EV;EAkFM;IACI,oBAAA;EAhFV;EAkFU;IACI,sBAAA;IACA,2BAAA;EAhFd;EAkFc;IACI,mBAAA;EAhFlB;EAqFM;IACI,aAAA;EAnFV;EAwFc;IACI,aAAA;EAtFlB;AACF;AA6FI;EACI,kBAAA;AA3FR","sourcesContent":["@use 'colors' as *;\n\n/* Rounded sliders */\n\n.slider.round {\n    border-radius: 20px;\n}\n\n.slider.round:before {\n    border-radius: 50%;\n}\n\ndiv.lunchtime {\n    div.header {\n        margin: 0 auto;\n        max-width: 1440px;\n        height: 56px;\n        display: flex;\n        align-items: center;\n        border-bottom: 1px solid $light-gray;\n        padding: 10px;\n\n        @media only screen and (max-width: 600px) {\n            height: 100px;\n        }\n\n        span {\n            &.title {\n                font-size: 32px;\n                line-height: 32px;\n                font-weight: bold;\n                color: white;\n                background-color: $cv-red;\n                padding: 12px;\n                box-sizing: border-box;\n            }\n\n            &.spacer {\n                display: none;\n            }\n\n            &.subtitle {\n                font-size: 24px;\n                opacity: 0.7;\n                flex-grow: 1;\n                padding-left: 30px;\n                padding-top: 5px;\n            }\n\n            &.user {\n                position: relative;\n                font-size: 14px;\n                color: $dark-gray;\n\n                .menu-login {\n                    background-color: $cv-red;\n                    color: white;\n                    border: none;\n                    border-radius: 8px;\n                    padding: 10px 12px;\n                    font-weight: 700;\n                    cursor: pointer;\n                    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);\n\n                    &:hover {\n                        background-color: $text-dark;\n                    }\n                }\n\n                .user-menu {\n                    position: relative;\n\n                    .menu-trigger {\n                        border: 1px solid $light-gray;\n                        background: white;\n                        color: $text-dark;\n                        border-radius: 6px;\n                        width: 40px;\n                        height: 36px;\n                        cursor: pointer;\n                        font-size: 18px;\n                        line-height: 1;\n                    }\n\n                    .menu-dropdown {\n                        position: absolute;\n                        right: 0;\n                        top: calc(100% + 8px);\n                        min-width: 220px;\n                        background: white;\n                        border: 1px solid $light-gray;\n                        border-radius: 8px;\n                        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.14);\n                        padding: 12px;\n                        z-index: 1200;\n\n                        .menu-user-name {\n                            font-weight: 600;\n                            color: $text-dark;\n                            margin-bottom: 4px;\n                            word-break: break-word;\n                        }\n\n                        .menu-user-email {\n                            font-size: 12px;\n                            color: $dark-gray;\n                            margin-bottom: 10px;\n                            word-break: break-word;\n                        }\n\n                        .menu-logout {\n                            width: 100%;\n                            background-color: $cv-red;\n                            color: white;\n                            border: none;\n                            border-radius: 8px;\n                            padding: 10px 12px;\n                            font-weight: 700;\n                            cursor: pointer;\n                            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);\n\n                            &:hover {\n                                background-color: $text-dark;\n                            }\n                        }\n\n                        .menu-avatar {\n                            width: 44px;\n                            height: 44px;\n                            border-radius: 50%;\n                            object-fit: cover;\n                            margin-bottom: 10px;\n                            border: 1px solid $light-gray;\n                        }\n                    }\n                }\n            }\n\n            #logout-button {\n                margin-left: 2px;\n            }\n        }\n    }\n\n    div.hero {\n        max-width: 1440px;\n        display: flex;\n        justify-content: space-around;\n        align-items: flex-start;\n        padding: 40px 0;\n        margin: 0 auto;\n\n        div.step {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            align-items: center;\n            width: 33%;\n            padding: 0 30px;\n\n            div.bubble {\n                height: 180px;\n                width: 180px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n\n                i.fa {\n                    color: $cv-red;\n                    font-size: 76px;\n                }\n            }\n\n            h2 {\n                color: $text-dark;\n                margin: 0 0 6px 0;\n                text-align: center;\n            }\n\n            article {\n                text-align: center;\n                width: 80%;\n                color: $dark-gray;\n                opacity: 0.8;\n            }\n        }\n    }\n\n    div.dates {\n        background-color: $dates-background;\n        box-sizing: border-box;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        padding: 20px 0 60px 0;\n        position: relative;\n\n        div.longterm {\n            position: absolute;\n            display: flex;\n            align-items: center;\n            cursor: pointer;\n            height: 50px;\n            top: 0;\n            right: 0;\n            padding-left: 5px;\n            padding-right: 5px;\n\n            @media only screen and (max-width: 600px) {\n                position: initial;\n                width: 100%;\n                justify-content: center;\n            }\n\n            .switch {\n                position: relative;\n                margin-left: 5px;\n                width: 43px;\n                height: 20px;\n                z-index: 2;\n            }\n            /* Hide default HTML checkbox */\n            .switch input {\n                display: none;\n            }\n            /* The slider */\n            .slider {\n                position: absolute;\n                cursor: pointer;\n                top: 0;\n                left: 0;\n                right: 0;\n                bottom: 0;\n                background-color: #ccc;\n                -webkit-transition: .4s;\n                transition: .4s;\n            }\n\n            .slider:before {\n                position: absolute;\n                content: \"\";\n                height: 24px;\n                width: 24px;\n                left: 0px;\n                bottom: -2px;\n                background-color: #ffffff;\n                -webkit-transition: .4s;\n                transition: .4s;\n                box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4);\n            }\n\n            input:checked + .slider {\n                background-color: #82c800;\n\n                &.beamer {\n                    background-color: #0064aa;\n                }\n            }\n\n            input:checked + .slider:before {\n                -webkit-transform: translateX(20px);\n                -ms-transform: translateX(20px);\n                transform: translateX(20px);\n            }\n        }\n\n        h1.date-title {\n            color: $text-dark;\n            font-size: 40px;\n            font-weight: 200;\n            align-self: center;\n            opacity: 0.8;\n            margin: 0;\n            padding: 0;\n        }\n\n        h2.date-subtitle {\n            font-weight: 100;\n            margin: 0;\n            margin-bottom: 40px;\n            font-size: 22px;\n            opacity: 0.6;\n\n\n            @media only screen and (max-width: 600px) {\n                margin-bottom: 60px;\n            }\n        }\n\n        div.appointments {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            div.day-group {\n                margin: 5px;\n            }\n\n            div.day {\n                width: 100%;\n                background-color: $text-dark;\n                color: white;\n                padding: 10px 0;\n                text-align: center;\n                font-size: 18px;\n                border-radius: 30px 30px 0 0;\n            }\n\n            div.appointments-row {\n                border: solid 1px;\n                padding-top: 10px;\n                padding-bottom: 10px;\n            }\n\n            div.appointment {\n                box-shadow: 0px 2px 0px 0px $light-gray;\n                border-radius: 30px;\n                height: 160px;\n                width: 200px;\n                margin: 0 20px;\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                cursor: pointer;\n                padding-bottom: 6px;\n                background-color: white;\n                position: relative;\n                margin-bottom: 20px;\n\n                div.check {\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    background-color: white;\n                    display: flex;\n                    flex-direction: column;\n                    justify-content: center;\n                    align-items: center;\n                    border-radius: 30px;\n                    height: 100%;\n                    width: 100%;\n                    opacity: 0;\n\n                    span {\n                        color: black;\n                    }\n\n                    i.fa {\n                        font-size: 60px;\n                        line-height: 70px;\n                        color: $cv-grass-dark;\n                    }\n                }\n\n                span {\n                    font-size: 14px;\n                }\n\n\n                div.combined {\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n                    justify-content: center;\n                    flex-grow: 1;\n\n                    span.big-number {\n                        color: $text-dark;\n                        font-size: 22px;\n                        line-height: 22px;\n                        font-weight: bold;\n                    }\n\n                    span.noon {\n                        margin-top: 10px;\n                        color: $text-dark;\n                        font-size: 28px;\n                        font-weight: bold;\n                        opacity: 1;\n                    }\n                }\n\n                &.selected {\n                    background-color: $cv-grass-medium;\n                    color: white;\n\n                    div.combined {\n                        span.big-number {\n                            color: white;\n                        }\n\n                        span.noon {\n                            color: white;\n                        }\n                    }\n                }\n\n                &.isLocked {\n                    opacity: 0.4;\n                    cursor: default;\n\n                    &:hover {\n                        box-shadow: 0px 2px 0px 0px $light-gray;\n                    }\n                }\n\n                &:hover {\n                    box-shadow: 0px 8px 14px 2px $light-gray;\n                }\n            }\n        }\n    }\n\n    div#login-hint {\n        padding: 20px;\n        background-color: $dates-background;\n        text-align: center;\n\n        .menu-login {\n            background-color: $cv-red;\n            color: white;\n            border: none;\n            border-radius: 8px;\n            padding: 10px 12px;\n            font-weight: 700;\n            cursor: pointer;\n            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);\n            margin: 0 6px;\n\n            &:hover {\n                background-color: $text-dark;\n            }\n        }\n    }\n\n    div.suggestions {\n        margin: 0 auto;\n        display: flex;\n        flex-direction: column;\n        padding: 20px 0;\n        margin-bottom: 20px;\n\n        h1 {\n            color: $text-dark;\n            font-size: 40px;\n            font-weight: 200;\n            align-self: center;\n            opacity: 0.8;\n            width: 570px;\n            text-align: center;\n        }\n\n        button {\n            align-self: center;\n            cursor: pointer;\n        }\n    }\n\n    div.footer {\n        background-color: $text-dark;\n        color: white;\n\n        div.links {\n            width: 80%;\n            padding: 20px;\n            box-sizing: border-box;\n            margin: 0 auto;\n            display: flex;\n            align-items: center;\n\n            h2 {\n                flex-grow: 1;\n            }\n\n            span {\n                margin: 0 10px;\n                opacity: 0.8;\n                font-size: 12px;\n                cursor: pointer;\n\n                &:hover {\n                    opacity: 1;\n                }\n            }\n        }\n    }\n}\n\nbutton.feedback-cta {\n    position: fixed;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    z-index: 1000;\n\n    background-color: $cv-red;\n    color: white;\n    border: none;\n    border-radius: 8px 0 0 8px;\n    padding: 12px 10px;\n    font-weight: 700;\n    cursor: pointer;\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);\n\n    writing-mode: vertical-rl;\n    text-orientation: mixed;\n    letter-spacing: 1px;\n    min-height: 120px;\n\n    &:hover {\n        background-color: $text-dark;\n    }\n}\n\nmodal#corona {\n    .corona-info {\n        padding: 20px 40px;\n    }\n}\n\nmodal#longterm {\n    .longterm-info {\n        padding: 20px 40px;\n    }\n}\n\n@media (max-width: 1024px), (orientation: portrait) {\n    div.modal {\n        display: none;\n    }\n\n    div.lunchtime {\n        div.header {\n            span.subtitle {\n                display: none;\n            }\n\n            span.spacer {\n                flex-grow: 1;\n                display: flex;\n            }\n        }\n\n        div.hero {\n            display: none;\n        }\n\n        div.dates {\n            padding-bottom: 40px;\n\n            div.appointments {\n                flex-direction: column;\n                justify-content: flex-start;\n\n                div.appointment {\n                    margin-bottom: 40px;\n                }\n            }\n        }\n\n        div.suggestions {\n            display: none;\n        }\n\n        div.footer {\n            div.links {\n                span {\n                    display: none;\n                }\n            }\n        }\n    }\n}   \n\nmodal#feedback {\n    .feedback {\n        padding: 20px 40px;\n    }\n}\n","$text-dark: #444;\n\n$dark-gray: rgba(0,0,0,0.6);\n$light-gray: rgba(0,0,0,0.10);\n\n$dates-background: rgba(0,0,0,0.05);\n\n// cornelsen colors\n$cv-red: rgb(222,41,34);\n$cv-grass-dark: rgb(107,171,45);\n$cv-grass-medium: rgb(177,198,16);\n$cv-grass-light: rgb(220,235,205);\n$cv-sky-dark: rgb(0,148,170);\n$cv-sky-medium: rgb(109,186,210);\n$cv-sky-light: rgb(210,235,235);\n$cv-sand-dark: rgb(175,157,140);\n$cv-sand-medium: rgb(212,202,189);\n$cv-sand-light: rgb(240,230,225);\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
